import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './utils/fil_winodw.js'
import 'antd/dist/antd.min.css'; // or 'antd/dist/antd.less'
import 'react-photo-view/dist/react-photo-view.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
